import {createStyles, makeStyles} from '@material-ui/core';
import {Theme} from 'feedback-system/with-root/typedef';

const styles = (theme: Theme) => createStyles({
    root: {
        width: '100%',
        maxWidth: '360px',
        backgroundColor: theme.palette.background.paper
    },
    normal: {
        fontFamily: theme.typography.fontFamily,
        color: '#555'
    },
    active: {
        fontFamily: theme.typography.fontFamily,
        fontWeight: 500,
        color: `${theme.palette.secondary.main} !important`,
        boxShadow: `inset 5px 0px 0px 0px ${theme.palette.primary.main}`
    },
    menuIcon: {
        width: 24,
        height: 24,
        marginRight: 10,
        color: 'red'
    }
});

export const useStyles = makeStyles(styles);
